import React from "react"

const CreateStudySessions = () => {
  return <div>Create Study Sessions</div>
}

export default CreateStudySessions
